import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { LIBRARY_SERVICE_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";

const SLICE = "actions";

interface ActionState {
  list: any[];
  actionDetails: any;
  status?: "idle" | "loading" | "failed";
  isCardVisited: boolean;
  totalRecords: number;
  actionShowLoader: boolean;
}

const initialState: ActionState = {
  list: [],
  isCardVisited: false,
  status: "idle",
  actionDetails: {},
  actionShowLoader: false,
  totalRecords: 0
};

export const fetchIndividualActionAsync = createAsyncThunk(
  `${SLICE}/fetchIndividualActionAsync`,
  (data: any, thunkApi) => apiRequest(LIBRARY_SERVICE_METHOD.postCards, data, thunkApi)
);

export const fetchIndividualActionDetailAsync = createAsyncThunk(
  `${SLICE}/fetchIndividualActionDetailAsync`,
  (data: any, thunkApi) => {
    const { id, ...args } = data;
    return apiRequest(LIBRARY_SERVICE_METHOD.getIndividualActionDetail, {}, thunkApi, [id], args);
  }
);

export const ActionSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    setIsCardVisited: (state, action) => {
      state.isCardVisited = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchIndividualActionAsync.pending, (state, action: any) => {
        state.status = "loading";
        state.actionShowLoader = action.meta.arg.pagination.page === 1;
      })
      .addCase(fetchIndividualActionAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.actionShowLoader = false;
        state.list =
          action.meta.arg.pagination.page === 1 ? action.payload.cards : [...state.list, ...action.payload.cards];
        state.totalRecords = action.payload.meta.page.total;
      })
      .addCase(fetchIndividualActionAsync.rejected, (state, action: any) => {
        state.status = "idle";
        state.actionShowLoader = false;
        state.list = [];
      })
      .addCase(fetchIndividualActionDetailAsync.pending, (state, action: any) => {
        state.status = "loading";
      })
      .addCase(fetchIndividualActionDetailAsync.fulfilled, (state, action: any) => {
        state.status = "idle";
        state.actionDetails = action.payload;
        state.isCardVisited = false;
      });
  }
});

export const { setIsCardVisited } = ActionSlice.actions;
export default ActionSlice.reducer;
